// @ts-nocheck
/* eslint-disable object-shorthand */
import Vue from 'vue'
const PopupConstructor = Vue.extend(require('./map-popup.vue').default)

const Popup = data => {
  const PopupInstance = new PopupConstructor({
    data: data
  })
  return PopupInstance.$mount().$el
}

export default {
  install: Vue => {
    Vue.prototype.$popup = Popup
  }
}
